export const getDialogStyle = () => ({
  dialog: {
    '& .ms-Dialog-actionsRight': {
      textAlign: 'left',
    },
  },
});
